import React from "react";
import { withStyles } from "@material-ui/core/styles";

const TextoEmNegrito = ({ children, classes, ...props }) => {
  return (
    <span className={classes.textoEmNegrito} {...props}>
      {children}
    </span>
  );
};

const styles = {
  textoEmNegrito: {
    fontWeight: "700",
    color: "#333333",
  },
};

export default withStyles(styles)(TextoEmNegrito);
